import MainLayout from "@/components/layout/company/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
const convertNumberService = new ConvertNumService();

export default {
    name: "companyDashboard",
    
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            company: {
                company_logo: "",
                company_name: "",
                email: "",
                phone_number: "",
                address: "",
                town: "",
                region: "",
                company_detail: ""
            },
            regionArr: RegionJson,
            id: this.$route.params.id,
            companyJobList: {},
            page_status: false
        };
    },

    methods: {
        getCompanyDetail() {
            axios.get("/company/dashboard/" + this.$route.params.id)
                .then(response => {
                    this.company = response.data;
                })
                .catch(error => {
                    console.log("Company Dashboard API Error", error);
                });
        },

        getJobCategoryInfo(page = 1) {
            axios.get("company/category/info/" + this.id + "?page=" + page)
                .then(response => {
                    this.companyJobList = response.data;
                    this.page_status = true;
                    this.job_count = convertNumberService.convertEng2Mm(this.companyJobList.total.toString())
                })
                .catch(error => {
                    console.log("Company Job Category Info API Error", error);
                });
        },

        getAllJobs(page = 1) {
            axios.get("/applicant/job/list?page=" + page)
                .then(response => {
                    this.companyJobList = response.data;
                    this.job_count = convertNumberService.convertEng2Mm(this.companyJobList.total.toString())
                })
                .catch(error => {
                    console.log("Get Jobs API Error", error);
                });
        },


        confirmDelete(id) {
            if (window.confirm("ဤအလုပ်ခေါ်ပိုစ့်ကိုဖျက်လိုပါသလား?")) {
                this.deleteJob(id);
            } else {
                console.log("no");
            }
        },

        deleteJob(id) {
            axios.delete("/job/delete/" + id)
                .then(response => {
                    this.companyJobList = response.data;
                    this.getJobCategoryInfo();
                })
                .catch(error => {
                    console.log("Job Delete Error->", error.response.data);
                })
        },

        getJobType(job_type) {
            if (job_type == '1') {
              this.job_type = 'Full-time';
            } else if (job_type == '2') {
              this.job_type = 'Part-time';
            } else if (job_type == '3') {
              this.job_type = 'Internship';
            } else if (job_type == '4') {
              this.job_type = 'Freelance';
            } else if (job_type == '5') {
                 this.job_type = 'Remote Job';
            } else {
              this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
          }
    },

    mounted() {
        this.getCompanyDetail();
        this.getJobCategoryInfo();
    }
};
